export const unitMap = {
    H: 'mm',
    Q: 'l/s',
    DSEA: 'm.NGF',
    P: 'mm',
    EXOG: 'kg.m-2.s-1',
  };
  
  export const purple = '#3B1C5C';
  
  export const colorPredefinedForecasts = (hours) => {
    switch (hours) {
      case 96:
        return "#A0F8B0";
      case 48:
        return "#FFD480";
      case 24:
        return "#228B22";
      case 12:
        return "#6EA4BF";
      case 6:
        return "#DE9ED6";
      default:
        return null;
    }
  };

  export const handleClickHelp = ({ setOpen, setSteps, steps }) => {
    setOpen(true);
    setSteps(steps);
  };

  export const sc2Timestamps = {
    startDate: 1609459200,
    endDate: 1617235200,
  };

  export const sc3Timestamps = {
    startDate: 1640736000,
    endDate: 1643068800,
  };

  export const sc4Timestamps = {
    startDate: 1672531200,
    endDate: 1675209600,
  };

  export const sc5Timestamps = {
    startDate: 1690848000,
    endDate: 1730419200,
  };

  export const fourDays = 345600;
